import React from 'react'

export interface StatCardProps {
  label: string
  value: string | number
  gradient: string
  icon?: string
  subtitle?: string
}

/**
 * Carte de statistique individuelle avec gradient de couleur.
 */
const StatCard: React.FC<StatCardProps> = ({ label, value, gradient, icon, subtitle }) => (
  <div
    data-testid="stat-card"
    style={{
      background: gradient,
      color: 'white',
      padding: '1.25rem 1.5rem',
      borderRadius: '0.75rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      minWidth: 0,
    }}
  >
    <p style={{ margin: 0, opacity: 0.9, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
      {icon && <span style={{ marginRight: '0.4rem' }}>{icon}</span>}
      {label}
    </p>
    <p style={{ margin: '0.4rem 0 0 0', fontSize: '1.75rem', fontWeight: '700', lineHeight: 1.2 }}>
      {value}
    </p>
    {subtitle && (
      <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.8rem', opacity: 0.8 }}>{subtitle}</p>
    )}
  </div>
)

export default StatCard
